import { MISSION_ENUM_TYPES } from '../../shared/constants'
import {
  browserSafeNewDate,
  dropTimeZoneFromDate,
  get24HourTime,
  getShortWeekDay,
  toLocaleNonAmericanDateString,
} from '../../shared/libraries/utils/date'
import { getDisplayedWeekNumber } from '../../Utils/Table'
import { calculateTimeOfDay } from '../../Utils/Mission'
import {
  calculateBonusCostForGQLMission,
  calculatePermitCostForGQLMission,
} from '../Campaigns/Page/MasterSchedule/util'

const formatToFixedNumber = (number, options = 2) =>
  number ? Number(Number(number).toFixed(options)) : 0

const foramtPivotTableMissionData = ({
  mission,
  city,
  campaign,
  campaignMissions,
  cityPlan,
}) => {
  const { location, user: ba, metricResults, type, label } = mission
  const locationName = location ? location.name : '-'

  const locationDependingOnTypeMission =
    type === MISSION_ENUM_TYPES.LETTERBOX ? label : locationName

  // Get a date relative to the missions timezone
  const localDate = browserSafeNewDate(dropTimeZoneFromDate(mission.dateTime))
  var data = {
    // Needed for links
    id: mission.id,
    'City': city.name,
    'Week': getDisplayedWeekNumber(localDate),
    'Date': toLocaleNonAmericanDateString(localDate),
    'Time': get24HourTime(localDate),
    'Time of day': calculateTimeOfDay(
      mission.dateTime,
      city.lunchCheckInTime,
      city.afternoonCheckInTime,
    ),
    'Day of week': getShortWeekDay(localDate.getDay()),
    'Location': locationDependingOnTypeMission,
    'BA': ba ? `${ba.firstName} ${ba.lastName}` : '-',
    'Code': mission.flyerCodeV2 ? mission.flyerCodeV2.code : '-',
    'Tag': mission.flyerCodeV2 ? mission.flyerCodeV2.tag : '-',
    'Flyers distributed': mission.totalFlyersDistributed || '-',
    'Status': (() => {
      if (mission.status == 'UNDER_REVIEW') return 'UNDER REVIEW'
      return mission.status
    })(),
    // Extra columns for exporting the data
    'Location Type': mission.location ? mission.location.type.name : '-',
    'Pack Size': mission.packSize,
    'Distribution Cost': mission.distributionCost,
    'Printing Cost': formatToFixedNumber(
      mission.totalFlyersDistributed * (mission.printingCostPerFlyer / 100),
    ),
    'Cost Per Flyer': mission.costPerFlyer || '-',
  }

  data['Cash Bonus'] = calculateBonusCostForGQLMission(mission)

  // Figure out the permit cost
  data['Permit Cost'] = formatToFixedNumber(
    calculatePermitCostForGQLMission({
      mission,
      cityPlan,
      campaignMissions,
    }),
  )

  data['Hard Cost'] = formatToFixedNumber(
    formatToFixedNumber(data['Distribution Cost']) +
      formatToFixedNumber(data['Printing Cost']) +
      formatToFixedNumber(data['Cash Bonus']) +
      formatToFixedNumber(data['Permit Cost']),
  )

  data['Scans'] = mission.amountScans

  metricResults.nodes.forEach(result => {
    const { metric, value } = result
    const campaignMetric = campaign.metrics.nodes.find(
      ({ id }) => id === metric.id,
    )
    const campaignMetricName = campaignMetric.label || campaignMetric.name
    data[campaignMetricName] = value
    data[`${campaignMetricName} CVR`] = value
      ? formatToFixedNumber(value / mission.totalFlyersDistributed, 4)
      : 0
    data[`Cost per ${campaignMetricName}`] =
      value == 0 ? '-' : formatToFixedNumber(data['Hard Cost'] / value)
  })

  // Link to the mission
  var { protocol, hostname, port } = window.location
  data['Link'] = `${protocol}//${hostname}${
    port ? ':' + port : ''
  }/dashboard/mission/${mission.id}`

  return data
}

export { foramtPivotTableMissionData }
